import React, { useState, useRef, useEffect } from "react";
import logo from "../../logo/temoc.png";
import dots from "../../logo/three-dot.gif"
import { Link } from "react-router-dom";
import Modal from "./Modal"

const { Configuration, OpenAIApi } = require("openai");

const configuration = new Configuration({
  apiKey: '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',
});
const openai = new OpenAIApi(configuration);

function TemocBotWithGPT() {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([{
    role: "system",
    content: `You are the University of Texas at Dallas Admissions counselor. 
    Do not let students know that you are an AI model or related to OpenAI, 
    pretend as if you are a real person. Your name is Temoc. And you cannot answer
    any questions that do not ask about your identity as a UTD counselor or any that is
    unrelated to UTDallas`
  }, {role: 'assistant', content: 'Hi! What can I help you with today?'}]);

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom();
    if (messages[messages.length - 1].role === 'user') {
      setLoading(true);
      openai.createChatCompletion({
        model: "gpt-3.5-turbo",
        messages: messages,
      }).then(data => {
        console.log(data);
        setMessages(messages => [...messages, {
          role: 'assistant',
          content: data.data.choices[0].message.content
        }]);
        setLoading(false);
      });
    }
  }, [messages]);

  useEffect(() => {
    scrollToBottom();
  }, [loading]);

  async function submitMessage(msg) {
    setQuery("");
    setMessages(messages => [...messages, {
      role: 'user',
      content: msg
    }]);
  }

  return (
    <div className='flex flex-col h-screen'>
      <Modal/>
      <div className='flex mt-8'>
        <p className='mt-2 ml-2 xl:ml-20 text-orange-500 text-3xl xl:text-7xl font-bold'>
          Temoc
        </p>
        <p className='mt-2 text-teal-900 text-3xl xl:text-7xl font-bold'>
          Talk
        </p>
        <Link to="/temoctalkwithmodel">
          <img className="w-12 xl:w-28" src={logo} alt="logo" />
        </Link>
        <div className='self-center w-full text-xl font-bold opacity-60 text-end xl:mr-20'>
          <Link to={'/'}>
            Back
          </Link>
        </div>
      </div>
      <div className={'bg-orange-500 xl:mr-20 xl:ml-20 mt-5 text-white font-semibold text-center text-xl xl:text-2xl py-8 px-4 duration-300 transition-all ' + (messages.length >= 3 ? 'hidden' : 'block')}>
          Welcome to TemocTalk! <br/>
          Ask any admission related question and let us help.
      </div> 
      <div className='bg-gray-200 xl:mr-20 xl:ml-20 h-full flex flex-col py-4 overflow-scroll'>
          {messages.map((message, idx) => {
            if (message.role === 'user') {
              return (
                <div key={idx} className='px-8 py-4 mx-4 my-2 rounded-xl bg-blue-400 max-w-xl self-end text-xl'>
                  {message.content}
                </div>
              )
            } else if (message.role === 'assistant') {
              return (
                <div key={idx} className='px-8 py-4 mx-4 my-2 rounded-xl bg-gray-400 max-w-xl self-start text-xl'>
                  {message.content}
                </div>
              )
            }
            return <div key={idx}></div>;
          })}
          {loading ? 
            <div className='px-8 py-4 mx-4 my-2 rounded-xl bg-gray-400 max-w-xl self-start text-xl'>
            <img className="w-12 xl:w-20" src={dots} alt="dots" />
            </div>: <></>}
          <div ref={messagesEndRef} />
      </div>
      <input 
        className='bg-emerald-400 h-40 xl:mr-20 xl:ml-20 text-green-900 p-2 rounded-none placeholder-green-700 outline-none text-xl px-10 mb-20'
        value={query}
        placeholder={"Enter your question here..."}
        onChange={e => {
          setQuery(e.target.value);
        }}
        onKeyPress={e => {
          if (e.key === 'Enter' && query !== '') {
            submitMessage(query);
          }
        }}
      />
    </div>
  );
}

export default TemocBotWithGPT;